import React, {Component} from 'react';
import {NavLink, withRouter} from 'react-router-dom';
import {injectIntl} from 'react-intl';
import {MODULE_TYPES} from '../../constants';
import {hasModule} from '../../forecast-app/shared/util/module_util';
import {hasFeatureFlag, usingTimeApproval} from '../../forecast-app/shared/util/FeatureUtil';
import {hasPermission} from '../../forecast-app/shared/util/PermissionsUtil';
import {PERMISSION_TYPE} from '../../Permissions';
import Util from '../../forecast-app/shared/util/util';

class PortfolioSectionHeader extends Component {
	constructor(props) {
		super(props);
		this.state = {
			hoveringSectionLink: false,
		};
	}

	componentDidUpdate(prevProps) {
		let prevPathEnding = localStorage.getItem('portfolio-section-last-viewed');
		const thisPathName = '/' + this.props.history.location.pathname.split('/')[1];
		const thisPathEnding = thisPathName + (this.props.history.location.hash || '');
		if (
			thisPathEnding !== prevPathEnding &&
			this.props.setPortfolioLastSection &&
			this.props.portfolioPath.includes(thisPathName)
		) {
			this.props.setPortfolioLastSection(thisPathEnding);
		}
	}

	getActiveIndicator() {
		return (
			<div className="active-indicator">
				<div className="border" />
			</div>
		);
	}
	onSectionLinkMouseEnter() {
		this.setState({hoveringSectionLink: true});
	}
	onSectionLinkMouseLeave() {
		this.setState({hoveringSectionLink: false});
	}

	navigationV2(navLinkBase, formatMessage) {
		const timeManagementPath = [];
		const timeApprovalAccess =
			usingTimeApproval(this.props.company) &&
			(hasPermission(PERMISSION_TYPE.MANAGE_ACCOUNT_SETTINGS) || this.props.isProjectOwner);
		const companyTimesheetAccess = Util.AuthorizeViewerAccess('team-time');
		if (timeApprovalAccess || companyTimesheetAccess) {
			timeManagementPath.push('/time-management');
		}
		const timeManagementName =
			timeApprovalAccess && companyTimesheetAccess
				? formatMessage({id: 'timesheet.time_management'})
				: timeApprovalAccess
				? formatMessage({id: 'timesheet.time_approval'})
				: formatMessage({id: 'timesheet.team_timesheet'});
		if (this.props.portfolioPath.length < 2) return null;
		return (
			<div className="my-profile-section-header">
				<nav className=" section-navigation old">
					<ul>
						{hasPermission(PERMISSION_TYPE.SCHEDULING_ACCESS) && (
							<>
								{this.props.portfolioPath.some(path => path === '/scheduling') ? (
									<li
										className="people-view"
										data-userpilot={'schedule-people-subheader'}
										data-cy={'portfolio-header-nav-point-schedule-people'}
									>
										<NavLink
											exact
											to={'/scheduling#people'}
											isActive={(match, location) =>
												location.pathname === '/scheduling' && location.hash === '#people'
											}
											className="scheduling-people"
											activeClassName="active"
										>
											<span title={formatMessage({id: 'scheduling.menu.schedule_people'})}>
												{formatMessage({id: 'scheduling.menu.schedule_people'})}
											</span>
											{this.getActiveIndicator()}
										</NavLink>
									</li>
								) : null}
								{this.props.portfolioPath.some(path => path === '/scheduling') ? (
									<li
										className="projects-view"
										data-userpilot={'schedule-projects-subheader'}
										data-cy={'portfolio-header-nav-point-schedule-projects'}
									>
										<NavLink
											exact
											to={'/scheduling#projects'}
											isActive={(match, location) =>
												location.pathname === '/scheduling' && location.hash === '#projects'
											}
											className="scheduling-projects"
											activeClassName="active"
										>
											<span title={formatMessage({id: 'scheduling.menu.schedule_projects'})}>
												{formatMessage({id: 'scheduling.menu.schedule_projects'})}
											</span>
											{this.getActiveIndicator()}
										</NavLink>
									</li>
								) : null}
							</>
						)}
						{timeManagementPath.length > 0 && !hasFeatureFlag('no_time_reg') ? (
							<li
								data-userpilot={'header-time-management'}
								data-cy={'portfolio-header-nav-point-time-management'}
							>
								<NavLink
									to={timeManagementPath[0]}
									className="time-management"
									isActive={(match, location) =>
										timeManagementPath.some(path => location.pathname.includes(path))
									}
								>
									<span title={timeManagementName}>{timeManagementName}</span>
									{this.getActiveIndicator()}
								</NavLink>
							</li>
						) : null}
						{hasModule(MODULE_TYPES.FINANCE, this.props.modules) && hasPermission(PERMISSION_TYPE.INVOICE_READ) && (
							<li data-userpilot={'header-invoicing'} data-cy={'portfolio-header-nav-point-invoicing'}>
								<NavLink to="/invoicing" className={'invoicing'} activeClassName="active">
									<span title={formatMessage({id: 'common.invoicing'})}>
										{formatMessage({id: 'common.invoicing'})}
									</span>
									{this.getActiveIndicator()}
								</NavLink>
							</li>
						)}
						{!hasPermission(PERMISSION_TYPE.INSIGHTS_READ) ? null : (
							<li data-userpilot={'header-reports'} data-cy={'portfolio-header-nav-point-insights'}>
								<NavLink
									to="/insights"
									className={'insights'}
									isActive={(match, location) =>
										location.pathname.includes('/insights') || location.pathname.includes('/saved-report')
									}
									activeClassName="active"
								>
									<span title={formatMessage({id: 'header.reports'})}>
										{formatMessage({id: 'header.reports'})}
									</span>
									{this.getActiveIndicator()}
								</NavLink>
							</li>
						)}
						{this.props.company.unit4Enabled &&
						Util.AuthorizeViewerAccess('unit4-log') &&
						this.props.availableFeatureFlags.some(flag => flag.key === 'unit4_error_log') ? (
							<li data-userpilot={'header-unit4-log'}>
								<NavLink
									to="/unit4log"
									className={'unit4log'}
									isActive={(match, location) => location.pathname.includes('/unit4log')}
									activeClassName="active"
								>
									<span title="Unit4 log">Unit4 log</span>
									{this.getActiveIndicator()}
								</NavLink>
							</li>
						) : null}
						{hasPermission(PERMISSION_TYPE.SISENSE_READ) && hasModule(MODULE_TYPES.SISENSE, this.props.modules) && (
							<li data-userpilot={'header-advanced-analytics'}>
								<NavLink
									to="/advanced-analytics"
									className={'advancedAnalytics'}
									isActive={(match, location) => location.pathname.includes('/advanced-analytics')}
									activeClassName="active"
								>
									<span title="Advanced Analytics">Advanced Analytics</span>
									{this.getActiveIndicator()}
								</NavLink>
							</li>
						)}
					</ul>
				</nav>
			</div>
		);
	}
	render() {
		const {formatMessage} = this.props.intl;
		const navLinkBase = `/`;
		return (
			<section>
				<div className={'section-main v2'}>{this.navigationV2(navLinkBase, formatMessage)}</div>
			</section>
		);
	}
}

export default withRouter(injectIntl(PortfolioSectionHeader));
